const getCSRCookieData = (name: string) => {
  if (typeof document === 'undefined') return null
  const cookieString = document.cookie
  const cookies = cookieString.split(';')
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim()
    if (cookie.startsWith(`${name}=`)) {
      return cookie.substring(name.length + 1)
    }
  }
  return null
}

export { getCSRCookieData }
